/**
 * @desc 修改合作企业
 */
import { BrandEntity, BrandForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateBrandParameter = BrandForm

const method = 'PUT'
const url = '/content/operation/brand'

export const updateBrandApi = (
  data?: UpdateBrandParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<BrandEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateBrandApi.method = method
updateBrandApi.url = url
